/* import __COLOCATED_TEMPLATE__ from './text-reply.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();